export default __webpack_public_path__ + "static/media/no-image-found.39acd288.png";